<template>
  <v-col :cols="cols">
    <v-card class="mx-1 mt-1 mb-1">
      <v-card-title class="pa-6 pb-3">
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-6 pt-0">
        <v-row no-gutters>
          <v-col cols="12" class="my-auto">
            <span
              class=""
              :style="{ 'font-size': textFontSize, 'font-weight': 'bold' }"
              >{{ titleNumber }}
            </span>
          </v-col>
          <v-col cols="12" class="my-auto">
            <span>
              {{ subTitle }}
            </span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-select
              :items="itemList"
              v-model="itemSelected"
              :label="titleNumber"
              solo
              return-object
              :item-text="itemText"
              :item-value="itemValue"
              @change="selectStateChange"
            >
              <template v-slot:selection="data">
                  {{ $t(data.item.name) }}
              </template>
              <template v-slot:item="data">
                  {{ $t(data.item.name) }}
              </template>
          </v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class DeviceOverviewSelectCard extends Vue {
  @Prop() titleNumber: any;
  @Prop() subTitle: any;
  @Prop() cols: any;
  @Prop() textFontSize: any;
  @Prop() control: any;
  @Prop() controlVariable: any;
  @Prop() itemList: any;
  @Prop() itemText: any;
  @Prop() itemValue: any;
  @Prop() value: any;

  currentValue: any;

  mounted() {
    this.currentValue = this.value;
  }

  get itemSelected() {
    return this.itemList.find((obj: any) => obj.value === this.value);
  }

  set itemSelected(selectedValue: any) {
    this.currentValue = selectedValue;
  }

  selectStateChange() {
    this.$emit("defaultAction", this.currentValue[this.itemValue], this.controlVariable);
  }
}
</script>

<style lang="scss">
@import "../../styles/app";

.dashboard-page {
  .page-title {
    padding-bottom: 20px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
  }
  .apexcharts-legend-series {
    padding: 2px 5px 3px;
    display: flex;
    align-items: center;
    .apexcharts-legend-marker {
      margin-right: 8px;
    }
  }
  .main-chart-select {
    font-size: 1rem;
    margin-right: 10px;
    fieldset {
      border-width: 1px !important;
      border-color: $text-grey !important;
      color: $text-grey !important;
    }
    .v-select__selection {
      color: $text-color !important;
    }
  }
  .v-card {
    .v-card__text {
      .subtext {
        font-size: 1.142rem;
        font-weight: 400;
        color: $title-grey;
      }
      .subtext-index {
        font-size: 11px;
        color: $text-color;
        font-weight: 400;
      }
    }
  }
}

.v-menu__content {
  box-shadow: $card-shadow !important;
  .v-list-item__content .v-list-item__title {
    font-size: 1rem;
    font-weight: 400;
  }
}
.button-shadow {
  box-shadow: $button-shadow;
}
</style>
